import { render, staticRenderFns } from "./addNewComplaintSettingModal.vue?vue&type=template&id=f4904406"
import script from "./addNewComplaintSettingModal.vue?vue&type=script&lang=js"
export * from "./addNewComplaintSettingModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports